export const translations = {
  pt: {
    // Header
    bookNow: "RESERVAR",

    // Slide Menu
    menu: {
      tapada: "Tapada de São Domingos",
      villas: "Villas",
      region: "A Região",
      reservations: "Reservas",
      contacts: "Contactos",
    },

    homeHero: {
      title: "Villas privadas junto ao Douro",
      tagline: "NATUREZA. ÁGUA. PRIVACIDADE ABSOLUTA.",
      features: [
        {
          icon: "leaf",
          title: "VILLAS PRIVADAS",
          description: "Sem espaços partilhados",
        },
        {
          icon: "droplet",
          title: "PISCINAS NATURAIS",
          description: "Água de nascente",
        },
        {
          icon: "leafWide",
          title: "PAISAGEM NATURAL",
          description: "Pura e preservada",
        },
        {
          icon: "pin",
          title: "PERTO DO PORTO",
          description: "A poucos minutos",
        },
      ],
    },

    diferenciacao: {
      kicker: "O QUE DISTINGUE A TAPADA",
      title: "Detalhes cuidados. Localização excecional.",
      lead:
        "Cada elemento da Tapada de São Domingos foi pensado para oferecer uma estadia exclusiva e inesquecível no Douro.",
      items: [
        { icon: "villa", title: "VILLAS PRIVADAS", subtitle: "Sem espaços partilhados" },
        { icon: "pool", title: "PISCINAS NATURAIS", subtitle: "Água de nascente" },
        { icon: "lock", title: "PRIVACIDADE ABSOLUTA", subtitle: "Total recato" },
        { icon: "tree", title: "PAISAGEM NATURAL", subtitle: "Pura e preservada" },
        { icon: "porto", title: "PERTO DO PORTO", subtitle: "A poucos minutos" },
        { icon: "superhost", title: "AIRBNB SUPERHOST", subtitle: "Estadias de confiança" },
        { icon: "star", title: "AVALIAÇÕES EXCECIONAIS", subtitle: "Preferido dos hóspedes" },
        { icon: "ev", title: "CARREGADOR EV", subtitle: "Carregamento para veículos elétricos" },
      ],
    },

    provaSocial: {
      kicker: "OS HÓSPEDES ADORAM FICAR CONNOSCO",
      title: "De confiança dos hóspedes. Reconhecida pela excelência.",
      lead:
        "Temos orgulho em oferecer experiências excecionais que os nossos hóspedes recordam — e recomendam.",
      booking: {
        score: "9.7",
        label: "Excecional",
        reviews: "Com base em avaliações verificadas de hóspedes",
      },
      testimonialLabel: "Avaliação de hóspede",
      testimonials: [
        {
          lines: [
            "Um lugar fantástico e o anfitrião mais maravilhoso.",
            "Piscina naturalmente filtrada adorável — nadámos todos os dias.",
          ],
        },
        {
          lines: [
            "Casa histórica única, perfeitamente localizada.",
            "Uma casa belíssima num grande domínio com vista para o rio Douro.",
          ],
        },
        {
          lines: [
            "A piscina era absolutamente incrível.",
            "A propriedade transmite muita privacidade.",
          ],
        },
        {
          lines: ["O lugar é como um paraíso."],
        },
        {
          lines: [
            "A estadia foi absolutamente fantástica.",
            "Pomares belíssimos e vistas deslumbrantes.",
          ],
        },
      ],
      superhost: {
        title: "SUPERHOST",
        platform: "Airbnb",
        description:
          "Distinção atribuída a anfitriões que oferecem estadias consistentemente excecionais.",
      },
    },

    // Bemvindo Section
    bemvindo: {
      line1:
        "Na lendária costa do norte de Portugal, a Tapada de São Domingos revela",
      line2:
        "a sua magnificência intemporal. Uma guardiã de séculos passados, esta",
      line3: "extraordinária residência incorpora o auge da hospitalidade",
      line4: "e romance.",
      subtitle1: "Um refúgio de calma e luxo discreto,",
      subtitle2: "onde cada momento convida à contemplação.",
    },

    // Pequena Descricao Section
    gardens: {
      section1: {
        subtitle: "OS JARDINS",
        title: "JARDINS CENTENÁRIOS",
        lead: "Um espaço moldado pela natureza, pela memória do lugar e pela beleza intemporal da paisagem",
        body: "Os jardins da Tapada de São Domingos acolhem um luxuriante tesouro botânico: castanheiros e carvalhos, glicínias, pomares de citrinos, camélias, ciprestes e oliveiras florescem ao lado de sebes esculpidas, fontes e vistas mitológicas.",
      },
      section2: {
        title: "UM PATRIMÓNIO VIVO",
        lead: "Entre os jardins e as fontes, um diálogo tranquilo desenrola-se entre arte e natureza, capturando a alma de um património secular.",
        body: "Aqui, cada elemento reflete serenidade e beleza intemporal — desde caminhos tranquilos ladeados por laranjeiras até à água suave que flui pela propriedade.",
      },
    },

    // Casas Section
    casas: {
      subtitle: "AS VILLAS",
      title: "REFÚGIOS ENCANTADORES À BEIRA-RIO",
      description:
        "Descubra as nossas casas, cada uma com a sua essência, conforto e vistas deslumbrantes sobre o vale do Douro. Escolha a villa ideal para a sua estadia perfeita.",
      leftText1:
        "Aninhadas ao longo das tranquilas margens do Douro, as nossas villas oferecem um refúgio íntimo onde a arquitetura patrimonial encontra o conforto moderno. Cada residência apresenta piscinas privadas, terraços à beira-rio e o charme intemporal da arte portuguesa.",
      leftText2:
        "Entre olivais antigos e jardins esculpidos, descobrirá espaços concebidos para o descanso e renovação. Acorde ao som do canto dos pássaros, jante ao ar livre sob as estrelas e mergulhe no ritmo descontraído da vida rural portuguesa.",
      viewVillas: "VER AS VILLAS",
    },

    // Region Section
    region: {
      subtitle: "A REGIÃO",
      title: "Visite o Norte de Portugal",
      lead: "Idealmente localizada entre o Porto e o Vale do Douro, a Tapada de São Domingos oferece a base perfeita para explorar o melhor do Norte de Portugal.",
      body: "A apenas 15 minutos do centro histórico do Porto e a uma curta viagem das vinhas em socalcos do Douro, desfrute de tranquilidade à beira-rio enquanto tem tudo ao seu alcance — gastronomia premiada, quintas centenárias, trilhos panorâmicos e vilas encantadoras.",
      exploreBtn: "EXPLORAR A REGIÃO",
    },

    // Contact Section
    contact: {
      subtitle: "CONTACTE-NOS",
      title1: "Estamos felizes em ajudá-lo",
      title2: "com qualquer pedido",
      visitUs: "VISITE-NOS",
      phoneNumber: "TELEFONE",
      email: "E-MAIL",
    },

    // Footer
    footer: {
      copyright: "© 2026 • Tapada de São Domingos",
    },

    // Region Detail Page
    regionDetail: {
      hero: {
        title: "O Norte de Portugal",
        description:
          "Do coração histórico do Porto às vinhas em socalcos do Douro, explore o melhor do Norte de Portugal a partir da Tapada de São Domingos.",
      },
      douro: {
        title: "O Vale do Douro",
        intro:
          "A Região do Douro, reconhecida pelas suas paisagens únicas onde se destacam os planaltos xistosos e encostas graníticas, emolduradas por correntes de águas límpidas, é um convite à descoberta. De carro, de comboio ou a bordo de um cruzeiro, ninguém fica indiferente à beleza e grandiosidade desta paisagem que, desde 2001, é Património Mundial da Humanidade.",
        paragraph1:
          "Cenário perfeito para os amantes da natureza, é um verdadeiro paraíso para os adeptos dos desportos de aventura e outras atividades ao ar livre.",
        visit: "Visite:",
        visitLink1: "Rota do Vinho do Porto em:",
        visitLink2: "Instituto dos Vinhos do Douro e Porto em:",
        visitLink3: "Caves de Vinho do Porto em:",
        activities: "Atividades",
        activity1Title: "Rio e Natureza",
        activity1Desc:
          "Passeios de barco no Douro, trilhos pela margem e miradouros com vistas panorâmicas sobre o vale.",
        activity2Title: "Cultura e Património",
        activity2Desc:
          "Cidades históricas, museus e igrejas que contam séculos de história e tradição nortenha.",
        activity3Title: "Experiências",
        activity3Desc:
          "Provas de vinho, visitas a quintas e cruzeiros no Douro para viver a região de forma autêntica.",
        nauticSports: "Desporto Náutico",
        nauticDesc:
          "A localização privilegiada da Tapada de S. Domingos potencia o desenvolvimento de atividades ligadas aos desportos náuticos. As marinas de Boialvo e Melres e os cais fluviais da Lixa (Covelo), Areja, Pé-de-Moura (Lomba) e Ribeira de Abade (Valbom) permitem explorar o rio em segurança.",
        cruises: "Cruzeiros no Douro em:",
      },
      porto: {
        title: "Cidade do Porto",
        heritage: "Património da Humanidade",
        intro:
          "O Porto é uma cidade única, que alia praia e cultura, antigo e contemporâneo, boa gastronomia e bons vinhos.",
        paragraph1:
          "Desde o Centro Histórico, classificado como Património Cultural da Humanidade, até à Foz, passando pela Casa da Música, Fundação de Serralves e o Parque da Cidade, não faltam motivos para passear e recantos para conhecer.",
        paragraph2:
          "A Tapada de S. Domingos, a apenas 10 minutos do Porto, oferece calma e contacto com a natureza, sem deixar de estar perto da vida noturna e cultural.",
        portWine: "Vinho do Porto",
        portWineDesc:
          "Produzido exclusivamente na Região Demarcada do Douro, o Vinho do Porto é um vinho generoso, envelhecido nas caves em Vila Nova de Gaia.",
        culture: "Cultura & Agenda",
        museum: "Museu de Arte Contemporânea em:",
        music: "Casa da Música em:",
        foundation: "Fundação Júlio Resende em:",
      },
      gondomar: {
        title: "Gondomar",
        intro:
          "Gondomar é um concelho conhecido pelo seu património, filigrana tradicional e forte identidade local, com paisagens ribeirinhas e uma vida cultural moldada pelo artesanato e pela tradição. Situada nesta zona tranquila da área metropolitana do Porto, a propriedade oferece uma estadia mais serena, mantendo o Porto a poucos minutos de distância.",
        visit: "Visite:",
        visitLink: "Câmara Municipal de Gondomar em:",
        museums: "Museus",
        museum1: "Museu da Ourivesaria e Relojoaria",
        museum2: "Casa Museu Soares dos Reis",
        heritage: "Património",
        heritage1: "Igreja Românica de Rio Tinto",
        heritage2: "Castro de Jovim",
      },
      cta: {
        text: "Pronto para descobrir o Douro a partir da Tapada de São Domingos?",
        button: "Ver disponibilidade",
      },
    },

    // Villa Detail Page
    villaDetail: {
      viewGallery: "Ver galeria",
      viewGalleryWithCount: "VER GALERIA ({count})",
      villaLabel: "VILLA",
      bedrooms: "Quartos",
      guests: "Hóspedes",
      floorPlan: "Planta da Casa",
      house: "A Villa",
      facilities: "Comodidades",
      pricing: "Preços",
      payment: "Detalhes de Pagamento",
      seasons: "Definição de Épocas",
      otherInfo: "Outras Informações",
      defaultHouseText:
        "A casa dispõe de duas suites com cama de casal e uma cozinha em openspace com sala de estar, outra casa de banho e um sofá‑cama. A cozinha está totalmente equipada e os quartos têm toalhas e lençóis à sua disposição. A casa possui Internet e TV por cabo.",
      paymentDeposit:
        "• Depósito de 30% necessário para reserva (reembolsável até 7 dias antes da chegada)",
      paymentSofaBed: "• Sofá‑cama/cama extra: €20/pessoa/dia",
      paymentMethods:
        "• Pagamento por transferência bancária ou em dinheiro à chegada",
      paymentSecurity: "• Caução de €200 (devolvida após inspeção)",
      paymentIncludes:
        "• Preços incluem IVA, AC, água, eletricidade, TV por satélite e internet",
      seasonsHigh:
        "• Época alta: 15 de junho a 15 de setembro, Réveillon (29 dez – 2 jan)",
      seasonsMid:
        "• Época média: 15 de março a 14 de junho, 16 de setembro a 21 de novembro",
      seasonsLow:
        "• Época baixa: 8 de janeiro a 14 de março, 22 de novembro a 28 de dezembro",
      otherCheckin: "• Check‑in: 16:00 | Check‑out: 12:00",
      otherTowels:
        "• Totalmente equipada com roupa de cama e toalhas (mão, banho e piscina)",
      otherWeekly:
        "• Troca semanal de toalhas para estadias superiores a 7 dias",
      otherCleaning: "• Limpeza geral incluída para estadias mais longas",
      otherAccessibility:
        "• Por favor, contacte‑nos relativamente a necessidades de acessibilidade",
      otherNoPets: "• Lamentamos, não são permitidos animais de estimação",
      booking: {
        datesLabel: "DATAS DA ESTADIA",
        datesPlaceholder: "Selecione as datas da estadia",
        roomsLabel: "NÚMERO DE QUARTOS",
        guestsLabel: "NÚMERO DE HÓSPEDES",
        selectNumber: "Selecione o número",
      },
    },

    // Reservation Page
    reservations: {
      heroSubtitle: "FIQUE NUMA VILLA",
      heroTitle: "Contacte-nos para encontrar a sua casa longe de casa",
      formTitle: "Os seus dados",
      requiredNote: "* Campos obrigatórios",
      firstName: "Primeiro nome",
      lastName: "Apelido",
      email: "E-mail",
      phone: "Número de telefone",
      dates: "Datas da estadia",
      selectDates: "Selecione as datas da estadia",
      checkIn: "Data de início",
      checkOut: "Data de fim",
      selectCheckIn: "Selecione a data de início",
      selectCheckOut: "Selecione a data de fim",
      villa: "Villa",
      adults: "Número de adultos",
      adultsPlaceholder: "Adultos",
      children: "Número de crianças",
      childrenPlaceholder: "Crianças",
      requests: "Pedidos",
      requestsPlaceholder: "Pedidos",
      minStayMessage: "Estadia mínima de 3 noites.",
      sendRequest: "ENVIAR PEDIDO",
      alertMessage:
        "Pedido enviado (simulado). Iremos implementar envio ao backend mais tarde.",
    },
  },
  en: {
    // Header
    bookNow: "BOOK NOW",

    // Slide Menu
    menu: {
      tapada: "Tapada de São Domingos",
      villas: "Villas",
      region: "The Region",
      reservations: "Reservations",
      contacts: "Contacts",
    },

    homeHero: {
      title: "Private Villas by the Douro",
      tagline: "NATURE. WATER. ABSOLUTE PRIVACY.",
      features: [
        {
          icon: "leaf",
          title: "PRIVATE VILLAS",
          description: "No shared areas",
        },
        {
          icon: "droplet",
          title: "NATURAL POOLS",
          description: "Spring water",
        },
        {
          icon: "leafWide",
          title: "NATURE SURROUNDINGS",
          description: "Pure and preserved",
        },
        {
          icon: "pin",
          title: "NEAR PORTO",
          description: "Minutes away",
        },
      ],
    },

    diferenciacao: {
      kicker: "WHAT SETS TAPADA APART",
      title: "Thoughtful details. Exceptional location.",
      lead:
        "Every element of Tapada de São Domingos is designed to offer an exclusive and unforgettable stay in the Douro.",
      items: [
        { icon: "villa", title: "PRIVATE VILLAS", subtitle: "No shared areas" },
        { icon: "pool", title: "NATURAL POOLS", subtitle: "Spring water" },
        { icon: "lock", title: "ABSOLUTE PRIVACY", subtitle: "Total seclusion" },
        { icon: "tree", title: "NATURE SURROUNDINGS", subtitle: "Pure and preserved" },
        { icon: "porto", title: "NEAR PORTO", subtitle: "Minutes away" },
        { icon: "superhost", title: "AIRBNB SUPERHOST", subtitle: "Trusted stays" },
        { icon: "star", title: "EXCEPTIONAL REVIEWS", subtitle: "Guest favorite" },
        { icon: "ev", title: "EV CHARGER", subtitle: "Electric vehicle charging" },
      ],
    },

    provaSocial: {
      kicker: "GUESTS LOVE STAYING WITH US",
      title: "Trusted by guests. Recognized for excellence.",
      lead:
        "We're proud to deliver exceptional experiences that our guests remember — and recommend.",
      booking: {
        score: "9.7",
        label: "Exceptional",
        reviews: "Based on verified guest reviews",
      },
      testimonialLabel: "Guest review",
      testimonials: [
        {
          lines: [
            "A fantastic place and the most wonderful host.",
            "Lovely naturally filtered pool we swam in every day.",
          ],
        },
        {
          lines: [
            "Perfectly located one-of-a-kind historical house.",
            "A beautiful house located within a large domain with a view to the Douro river.",
          ],
        },
        {
          lines: [
            "The pool was absolutely amazing.",
            "The property feels very private.",
          ],
        },
        {
          lines: ["The place is like a paradise."],
        },
        {
          lines: [
            "The stay was absolutely fantastic.",
            "Beautiful orchards and amazing views.",
          ],
        },
      ],
      superhost: {
        title: "SUPERHOST",
        platform: "Airbnb",
        description:
          "Awarded to hosts who consistently deliver outstanding stays.",
      },
    },

    // Bemvindo Section
    bemvindo: {
      line1:
        "On the legendary coast of northern Portugal, Tapada de São Domingos reveals",
      line2: "its timeless magnificence. A guardian of centuries past, this",
      line3: "extraordinary residence embodies the pinnacle of hospitality",
      line4: "and romance.",
      subtitle1: "A haven of calm and discreet luxury,",
      subtitle2: "where every moment invites contemplation.",
    },

    // Pequena Descricao Section
    gardens: {
      section1: {
        subtitle: "THE GROUNDS",
        title: "CENTURIES-OLD GARDENS",
        lead: "A space shaped by nature, by the memory of place, and by the timeless beauty of the landscape.",
        body: "Tapada de São Domingos' gardens host a luxuriant botanical treasure: chestnut and oak trees, wisteria, citrus groves, camellias, cypresses and olive trees flourish alongside sculpted hedges, fountains and mythological vistas.",
      },
      section2: {
        title: "A LIVING HERITAGE",
        lead: "Among the gardens and fountains, a peaceful dialogue unfolds between art and nature, capturing the soul of centuries-old heritage.",
        body: "Here, each element reflects serenity and timeless beauty — from quiet paths lined with orange trees to the gentle water flowing through the estate.",
      },
    },

    // Casas Section
    casas: {
      subtitle: "THE VILLAS",
      title: "CHARMING RIVERSIDE RETREATS",
      description:
        "Discover our houses, each with its own essence, comfort and stunning views over the Douro valley. Choose the ideal villa for your perfect stay.",
      leftText1:
        "Nestled along the tranquil Douro riverbanks, our villas offer an intimate escape where heritage architecture meets modern comfort. Each residence features private pools, riverside terraces, and the timeless charm of Portuguese craftsmanship.",
      leftText2:
        "Among ancient olive groves and sculpted gardens, you'll discover spaces designed for rest and renewal. Wake to the sound of birdsong, dine al fresco beneath the stars, and immerse yourself in the unhurried rhythm of rural Portuguese life.",
      viewVillas: "VIEW THE VILLAS",
    },

    // Region Section
    region: {
      subtitle: "THE REGION",
      title: "Visit Northern Portugal",
      lead: "Ideally located between Porto and the Douro Valley, Tapada de São Domingos offers the perfect base to explore the best of Northern Portugal.",
      body: "Just 15 minutes from Porto's historic center and a short trip from the Douro's terraced vineyards, enjoy riverside tranquility while having everything at your fingertips — award-winning gastronomy, centuries-old quintas, panoramic trails and charming villages.",
      exploreBtn: "EXPLORE THE REGION",
    },

    // Contact Section
    contact: {
      subtitle: "CONTACT US",
      title1: "We are happy to assist",
      title2: "you with any request",
      visitUs: "COME VISIT US",
      phoneNumber: "PHONE NUMBER",
      email: "E-MAIL",
    },

    // Footer
    footer: {
      copyright: "© 2026 • Tapada de São Domingos",
    },

    // Region Detail Page
    regionDetail: {
      hero: {
        title: "The North of Portugal",
        description:
          "From Porto's historic heart to the Douro's terraced vineyards, explore the best of Northern Portugal from Tapada de São Domingos.",
      },
      douro: {
        title: "The Douro Valley",
        intro:
          "The Douro Region, recognized for its unique landscapes featuring schist plateaus and granite slopes, framed by clear water streams, is an invitation to discovery. By car, train or aboard a cruise, no one remains indifferent to the beauty and grandeur of this landscape which, since 2001, has been a UNESCO World Heritage Site.",
        paragraph1:
          "A perfect setting for nature lovers, it is a true paradise for adventure sports enthusiasts and other outdoor activities.",
        visit: "Visit:",
        visitLink1: "Port Wine Route at:",
        visitLink2: "Douro and Port Wine Institute at:",
        visitLink3: "Port Wine Cellars at:",
        activities: "Activities",
        activity1Title: "River and Nature",
        activity1Desc:
          "Boat trips on the Douro, riverside trails and viewpoints with panoramic views over the valley.",
        activity2Title: "Culture and Heritage",
        activity2Desc:
          "Historic cities, museums and churches that tell centuries of northern history and tradition.",
        activity3Title: "Experiences",
        activity3Desc:
          "Wine tastings, quinta visits and Douro cruises to experience the region authentically.",
        nauticSports: "Nautical Sports",
        nauticDesc:
          "The privileged location of Tapada de S. Domingos promotes the development of activities related to water sports. The marinas of Boialvo and Melres and the river docks of Lixa (Covelo), Areja, Pé-de-Moura (Lomba) and Ribeira de Abade (Valbom) allow you to explore the river safely.",
        cruises: "Douro cruises at:",
      },
      porto: {
        title: "City of Porto",
        heritage: "World Heritage",
        intro:
          "Porto is a unique city that combines beach and culture, old and contemporary, good food and fine wines.",
        paragraph1:
          "From the Historic Center, classified as a UNESCO World Heritage Site, to Foz, passing by Casa da Música, Serralves Foundation and City Park, there are plenty of reasons to stroll and corners to discover.",
        paragraph2:
          "Tapada de S. Domingos, just 10 minutes from Porto, offers calm and contact with nature, while still being close to nightlife and culture.",
        portWine: "Port Wine",
        portWineDesc:
          "Produced exclusively in the Douro Demarcated Region, Port Wine is a fortified wine, aged in cellars in Vila Nova de Gaia.",
        culture: "Culture & Events",
        museum: "Contemporary Art Museum at:",
        music: "Casa da Música at:",
        foundation: "Júlio Resende Foundation at:",
      },
      gondomar: {
        title: "Gondomar",
        intro:
          "Gondomar is a municipality known for its heritage, traditional filigree and strong local identity, with riverside landscapes and a cultural life shaped by craftsmanship and tradition. Set in this peaceful part of the Porto metropolitan area, the property offers a quieter stay while keeping Porto just minutes away.",
        visit: "Visit:",
        visitLink: "Gondomar City Council at:",
        museums: "Museums",
        museum1: "Goldsmithing and Watchmaking Museum",
        museum2: "Soares dos Reis House Museum",
        heritage: "Heritage",
        heritage1: "Romanesque Church of Rio Tinto",
        heritage2: "Castro de Jovim",
      },
      cta: {
        text: "Ready to discover the Douro from Tapada de São Domingos?",
        button: "Check availability",
      },
    },

    // Villa Detail Page
    villaDetail: {
      viewGallery: "View gallery",
      viewGalleryWithCount: "VIEW GALLERY ({count})",
      villaLabel: "VILLA",
      bedrooms: "Bedrooms",
      guests: "Guests",
      floorPlan: "Floor Plan",
      house: "The Villa",
      facilities: "Facilities",
      pricing: "Pricing",
      payment: "Payment Details",
      seasons: "Definition of Seasons",
      otherInfo: "Other Information",
      defaultHouseText:
        "The house has two double room suites and an open‑space kitchen and living room with another bathroom and a sofa bed. The kitchen is fully furnished, the bedrooms have towels and sheets at your disposal. The house has Internet and Cable TV.",
      paymentDeposit:
        "• 30% deposit required for reservation (refundable up to 7 days before arrival)",
      paymentSofaBed: "• Sofa bed/extra bed: €20/person/day",
      paymentMethods: "• Payment by bank transfer or cash on arrival",
      paymentSecurity: "• €200 security deposit (returned after inspection)",
      paymentIncludes:
        "• Prices include VAT, AC, water, electricity, satellite TV and internet",
      seasonsHigh:
        "• High season: June 15 to September 15, New Year's Eve (29 Dec – 2 Jan)",
      seasonsMid:
        "• Middle season: March 15 to June 14, September 16 to November 21",
      seasonsLow:
        "• Low season: January 8 to March 14, November 22 to December 28",
      otherCheckin: "• Check‑in: 4:00 PM | Check‑out: 12:00 PM",
      otherTowels:
        "• Fully equipped with bed linen and towels (hand, bath, and pool towels)",
      otherWeekly: "• Weekly towel change for stays over 7 days",
      otherCleaning: "• General cleaning included for longer stays",
      otherAccessibility: "• Please contact us regarding accessibility needs",
      otherNoPets: "• Sorry, no pets allowed",
      booking: {
        datesLabel: "DATES OF STAY",
        datesPlaceholder: "Select dates of stay",
        roomsLabel: "ROOMS NUMBER",
        guestsLabel: "GUEST NUMBER",
        selectNumber: "Select number",
      },
    },

    // Reservation Page
    reservations: {
      heroSubtitle: "STAY IN A VILLA",
      heroTitle: "Contact us to find your perfect home away from home",
      formTitle: "Your data",
      requiredNote: "* Required fields",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone number",
      dates: "Dates of stay",
      selectDates: "Select dates of stay",
      checkIn: "Start date",
      checkOut: "End date",
      selectCheckIn: "Select start date",
      selectCheckOut: "Select end date",
      villa: "Villa",
      adults: "Number of adults",
      adultsPlaceholder: "Adults",
      children: "Number of children",
      childrenPlaceholder: "Children",
      requests: "Requests",
      requestsPlaceholder: "Requests",
      minStayMessage: "Minimum stay is 3 nights.",
      sendRequest: "SEND THE REQUEST",
      alertMessage:
        "Request sent (simulated). We will implement backend submission later.",
    },
  },
};

export default translations;

export const getTranslation = (language, key) => {
  const keys = key.split(".");
  let value = translations[language];

  for (const k of keys) {
    if (value && typeof value === "object") {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }

  return value || key;
};
